import { paramsToQueryKey } from '@/shared/lib/react-query';

const PREFIX = 'reconciliation';

export const ReconciliationQueryKeys = {
  documentDetails: (orderGuid: string) => paramsToQueryKey([PREFIX], { orderGuid, type: 'document-details' }),
  log: (orderGuid: string) => paramsToQueryKey([PREFIX], { orderGuid, type: 'log' }),
  unboundBindings: (orderGuid: string) => paramsToQueryKey([PREFIX], { orderGuid, type: 'unbound-bindings' }),
};
